import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import Page from '../../common/components/Page';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import WelcomeHero from './WelcomeHero';
import Dropdown from '../../common/components/Dropdown';
import Button from '../../common/components/Button';
import extractText from '../../common/utils/extractText';
import PageStructure from './PageStructure';
import IndexSidebar from './IndexSidebar';
import PostList from './PostList';
import PostListState from '../states/PostListState';
/**
 * The `PostsPage` component displays the index page, including the welcome
 * hero, the sidebar, and the discussion list.
 */
export default class PostsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "posts", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.posts = new PostListState({});
    this.posts.refreshParams(app.search.state.params(), m.route.param('page') && Number(m.route.param('page')) || 1);
    app.history.push('posts', extractText(app.translator.trans('core.forum.header.back_to_index_tooltip')));
    this.bodyClass = 'App--posts';
    this.scrollTopOnCreate = false;
  }
  view() {
    return m(PageStructure, {
      className: "PostsPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this)
    }, m("div", {
      className: "IndexPage-toolbar PostsPage-toolbar"
    }, m("ul", {
      className: "IndexPage-toolbar-view PostsPage-toolbar-view"
    }, listItems(this.viewItems().toArray())), m("ul", {
      className: "IndexPage-toolbar-action PostsPage-toolbar-action"
    }, listItems(this.actionItems().toArray()))), m(PostList, {
      state: this.posts
    }));
  }
  setTitle() {
    app.setTitle(extractText(app.translator.trans('core.forum.posts.meta_title_text')));
    app.setTitleCount(0);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.setTitle();
  }
  onremove(vnode) {
    super.onremove(vnode);
    $('#app').css('min-height', '');
  }

  /**
   * Get the component to display as the hero.
   */
  hero() {
    return m(WelcomeHero, null);
  }
  sidebar() {
    return m(IndexSidebar, null);
  }

  /**
   * Build an item list for the part of the toolbar which is concerned with how
   * the results are displayed. By default this is just a select box to change
   * the way discussions are sorted.
   */
  viewItems() {
    const items = new ItemList();
    const sortMap = this.posts.sortMap();
    const sortOptions = Object.keys(sortMap).reduce((acc, sortId) => {
      acc[sortId] = app.translator.trans("core.forum.posts_sort.".concat(sortId, "_button"));
      return acc;
    }, {});
    if (Object.keys(sortOptions).length > 1) {
      items.add('sort', m(Dropdown, {
        buttonClassName: "Button",
        label: sortOptions[app.search.state.params().sort] || Object.keys(sortMap).map(key => sortOptions[key])[0],
        accessibleToggleLabel: app.translator.trans('core.forum.posts_sort.toggle_dropdown_accessible_label')
      }, Object.keys(sortOptions).map(value => {
        const label = sortOptions[value];
        const active = (app.search.state.params().sort || Object.keys(sortMap)[0]) === value;
        return m(Button, {
          icon: active ? 'fas fa-check' : true,
          onclick: () => app.search.state.changeSort(value),
          active: active
        }, label);
      })));
    }
    return items;
  }

  /**
   * Build an item list for the part of the toolbar which is about taking action
   * on the results. By default this is just a "mark all as read" button.
   */
  actionItems() {
    const items = new ItemList();
    items.add('refresh', m(Button, {
      title: app.translator.trans('core.forum.posts.refresh_tooltip'),
      "aria-label": app.translator.trans('core.forum.posts.refresh_tooltip'),
      icon: "fas fa-sync",
      className: "Button Button--icon",
      onclick: () => {
        this.posts.refresh();
        if (app.session.user) {
          app.store.find('users', app.session.user.id());
          m.redraw();
        }
      }
    }));
    return items;
  }
}
_defineProperty(PostsPage, "providesInitialSearch", true);
flarum.reg.add('core', 'forum/components/PostsPage', PostsPage);